import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import cardImagesServices from '@src/services/cardImages.services';

export const cardImagesGetByVouId = createAsyncThunk(
  'cardImagesGetByVouId',
  async (vouId, { rejectWithValue }) => {
    try {
      return await cardImagesServices.getCardImages(vouId);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const cardImagesGetList = createAsyncThunk(
  'cardImagesGetList',
  async ({ pageNumber, pageSize }, { rejectWithValue }) => {
    try {
      return await cardImagesServices.cardImagesGetList(pageNumber, pageSize);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const cardImagesUpdate = createAsyncThunk(
  'cardImagesUpdate',
  async (data, { rejectWithValue }) => {
    try {
      return await cardImagesServices.cardImagesUpdate(data);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const cardImageDelete = createAsyncThunk(
  'cardImageDelete',
  async (data, { rejectWithValue }) => {
    try {
      return await cardImagesServices.cardImageDelete(data);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const cardImagesAdd = createAsyncThunk(
  'cardImagesAdd',
  async (data, { rejectWithValue }) => {
    try {
      return await cardImagesServices.cardImagesAdd(data);
    } catch (error) {
      return rejectWithValue(error?.data);
    }
  },
);

export const cardImagesSlice = createSlice({
  name: 'cardImages',
  initialState: {
    cardImages: [],
    cardImagesList: [],
    editableData: {},
    pageProperty: {
      currentPage: 1,
      page: 1,
      pageSize: 10,
      totalCount: 0,
    },
  },
  reducers: {
    setEditableData: (state, action) => {
      state.editableData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(cardImagesGetByVouId.fulfilled, (state, action) => {
      state.cardImages = action?.payload?.data;
    });
    builder.addCase(cardImagesGetList.fulfilled, (state, action) => {
      state.cardImagesList = action?.payload?.data?.items || [];
      state.pageProperty = action?.payload?.data?.pagedProperty || {};
    });
    builder.addCase(cardImagesGetList.rejected, (state, action) => {
      state.cardImagesList = [];
      state.pageProperty = {
        currentPage: 1,
        page: 1,
        pageSize: 10,
        totalCount: 0,
      };
    });
  },
});

export const { setEditableData } = cardImagesSlice.actions;
